const LOCALE_PREFIXES = ['de', 'en'];

/** Native language names for locale switchers (not translated). */
export const LOCALE_DISPLAY_NAMES: Record<(typeof LOCALE_PREFIXES)[number], string> = {
    de: 'Deutsch',
    en: 'English',
};

/** Flag emojis for locale switchers. */
export const LOCALE_FLAGS: Record<(typeof LOCALE_PREFIXES)[number], string> = {
    de: '🇩🇪',
    en: '🇺🇸',
};

/**
 * Get localized URLs for both languages for a given path
 */
export const getLocalizedUrls = (currentPath: string): { de: string; en: string } => {
    const cleanPath = stripLocaleFromPath(currentPath);

    return {
        de: `/de${cleanPath}`,
        en: `/en${cleanPath}`,
    };
};

/**
 * Extract locale from URL path
 */
export const getLocaleFromUrl = (path: string): 'de' | 'en' => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    for (const locale of LOCALE_PREFIXES) {
        if (cleanPath.startsWith(`/${locale}/`) || cleanPath === `/${locale}`) {
            return locale as 'de' | 'en';
        }
    }

    return 'de';
};

/**
 * Strip locale prefix from path
 */
export const stripLocaleFromPath = (path: string): string => {
    if (!path.startsWith('/')) {
        path = `/${path}`;
    }

    for (const locale of LOCALE_PREFIXES) {
        const prefix = `/${locale}/`;
        if (path.startsWith(prefix)) {
            return path.substring(prefix.length - 1);
        }

        if (path === `/${locale}`) {
            return '/';
        }
    }

    return path;
};

/**
 * Check if the current path is a marketing page
 */
export const isMarketingPage = (path: string): boolean => {
    const cleanPath = stripLocaleFromPath(path);

    const marketingPages = [
        '/',
        '/impressum',
        '/datenschutz',
        '/agb',
        '/mietkautionskonto',
        '/mietkautionskonto-vergleich',
        '/mietkautionskonto-kosten',
        '/zinsen-bei-mietkautionskonten',
        '/mietkaution-rechtssicher-anlegen',
    ];

    return marketingPages.includes(cleanPath);
};
